<div class="container" [hidden]='!loading'>
    <img [hidden]='!loading' [class]="loading?'mx-auto d-block':''" src="assets/images/loading.gif">
</div>

<div class="container text-center" [hidden]='loading'>
    <img src="assets/images/main_logo.png" alt="Logo" class="logo img-fluid">
    <h2 class="mt-3">Thank you for completing the KYC form! We appreciate your time and effort. Our team is reviewing your submission, and we will get back to you once the form has been processed.</h2>
</div>